import * as z from "zod/v4";

export const disconnectJudgeMeIntegration = {
  name: "disconnectJudgeMeIntegration" as const,
  input: z.null(),
  output: z.null(),
};
